import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";

const img = (name) => `${process.env.PUBLIC_URL}/images/online-session/${name}`;

const otherSessionExperts = [
  {
    no: 1,
    name: "Prof. Masanori Akiyoshi",
    title: "Professor, Vice President of Kanagawa University, Japan",
    affiliation: "Kanagawa University",
    affiliationZh: "神奈川大学",
    photo: "akiyoshi.jpg",
  },
  {
    no: 2,
    name: "Prof. Nobuo Kawaguchi",
    title:
      "Professor, Institute of Innovation for Future Society and Graduate School of Engineering, Nagoya University, Japan",
    affiliation: "Nagoya University",
    affiliationZh: "名古屋大学",
    photo: "kawaguchi.jpg",
  },
  {
    no: 3,
    name: "Prof. Yuji Sato",
    title: "Professor, Faculty of Information Sciences, Hosei University, Japan",
    affiliation: "Hosei University",
    affiliationZh: "法政大学",
    photo: "sato.jpg",
  },
  {
    no: 4,
    name: "Dr. Jia Guo",
    title: "Assistant Professor, Nagoya University, Japan",
    affiliation: "Nagoya University",
    affiliationZh: "名古屋大学",
    photo: "jiaguo.jpg",
  },
];

const OtherSession = () => {
  return (
    <React.Fragment>
      <SEO title="Other Session | ICSI 2026" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Other Session"
        content="The Conference"
        contentTwo="Other Session"
        linkage="/"
      />

      <EmptyTwo>
        <div className="entry-content online-session-page">
          <h2>ICSI&apos;2026 Other Session</h2>
          <p>
            ICSI&apos;2026 was held in a hybrid format. In addition to the onsite
            program in Beijing, other session activities were arranged for remote
            participation and expert attendance.
          </p>

          <section className="online-session-block">
            <h3>Session Chair</h3>
            <div className="online-session-chair-card">
              <p className="online-session-chair-name">JIACHENG LI</p>
              <p className="online-session-chair-aff">
                Kanagawa University, Yokohama, Japan
              </p>
            </div>
          </section>

          <section className="online-session-block">
            <h3>Expert Attendance</h3>
            <p>
              The following experts joined the ICSI&apos;2026 other session. We
              sincerely thank them for their participation and support.
            </p>

            <div className="online-expert-grid">
              {otherSessionExperts.map((expert) => (
                <article className="online-expert-card" key={expert.no}>
                  <div className="online-expert-photo">
                    <img src={img(expert.photo)} alt={expert.name} />
                  </div>
                  <div className="online-expert-info">
                    <p className="online-expert-no">No. {expert.no}</p>
                    <h4>{expert.name}</h4>
                    <p className="online-expert-title">{expert.title}</p>
                    <p className="online-expert-aff">
                      {expert.affiliation} / {expert.affiliationZh}
                    </p>
                  </div>
                </article>
              ))}
            </div>
          </section>
        </div>
      </EmptyTwo>

      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default OtherSession;
